import React from 'react'
import './Toggle.scss';
const Toggle = ({setTheme}) => {
    const handleTheme = () =>{
        setTheme()
    }
    return (
        <div className="toggle">
            <input onChange={handleTheme}type="checkbox" id="toggle" name="toggle" value="is_on" />
                <label htmlFor="toggle" className="toy-toggle">
                    <span className="border1"></span>
                    <span className="border2"></span>
                    <span className="border3"></span>
                    <span className="handle">
                        <span className="handle-off"></span>
                        <span className="handle-on"></span>
                    </span>
                </label>
        </div>
    )
}

export default Toggle
